import RuleIcon from "@mui/icons-material/Rule";
import permissions from "app/permissions";
import { DoctoralServicePath } from "utils/constants";
import DoctoralSeatApprovalsPage from "./Page";

export const resources = {
  isMenu: true,
  icon: <RuleIcon />,
  name: `${DoctoralServicePath}doctoral-seats/approvals`,
  title: "Одобрение на докторантски места",
  list: <DoctoralSeatApprovalsPage />,
  permission: [
    permissions.canApproveDoctoralSeatsByFc,
    permissions.canApproveDoctoralSeatsByAc,
    permissions.canApproveDoctoralSeatsByMon,
  ],
};
